import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { showSnackBar } from "../../utils/commonServices";
import { acceptMemberInvitationApi, checkInvitationApi, checkResetTokenValidityApi, checkSessionApi, checkVerificationTokenApi, createGuestLogApi, forgotPasswordApi, getGuestEventDetailsApi, registerGuestApi, resetPasswordApi, unsignedCheckSessionApi, userSigninApi } from "../../services/api";
import { setGuestReviewState } from "../../redux/guestSlice";
import { setTheme } from "../../redux/customThemeSlice";
import { getTheme } from "../whitelabel/actions";
import { getPermissions } from "../../commonactions/actions";
import { updateState } from "../../redux/commonSlice";
import { setAssetState } from "../../redux/assetSlice";
import { gaEvents } from "../../ga/actions";
import { updateProjectState } from "../../redux/projectSlice";
import { FaBullseye } from "react-icons/fa";
import { updatePendingCallState } from "../../redux/pendingCallSlice";
import { setSnackbar } from "../../redux/messageSlice";



export default ()=> {
 
  const dispatch = useDispatch();
  const commonReducer = useSelector(state=> state.root.commonReducer)
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const code = query.get('c')
  const guestReducer = useSelector(state=> state.guestReducer)
  const navigate = useNavigate();



    const signinUser = (payload, callback ) => {
      dispatch(updatePendingCallState({signin: true}))
      userSigninApi(payload) 
      .then((response) => {
        //console.log("response", response?.data)
        dispatch(updatePendingCallState({signin: false}))
        if(response?.data?.http_code == 200){
           // //setSigninStatus("success");
            gaEvents.loginEvent()
            window.localStorage.setItem("token", response?.data?.data?.token);
            dispatch(
              updateState({
                is_logged: true,
                user_name: response?.data?.data?.name,
                user_id: response?.data?.data?.id,
                // company_name:response?.data?.company_name,
                // show_revision_tutorial: response?.data?.show_revision_tutorial,
                // is_company_name_available: response?.data?.company_name  ? true : false,
              })
            );
            dispatch(updateProjectState({is_org_projects_loading: true}))
            // dispatch(setAssetState({
            //   is_brand_name_available: response?.data?.company_name  ? true : false,
            // }))
      
            getPermissions(dispatch)
            // getTheme(dispatch)
           
            navigate("/", {replace: true});
          // console.log(response.data.data.guest_reviewer_id)
        //   getGuestEventDetails({slug:code, guest_reviewer_id: response?.data?.data?.guest_reviewer_id }, callback)
        //   dispatch(setGuestReviewState({guest_reviewer_id: response.data.data.guest_reviewer_id}))
        //  callback && callback()
          // getGuestEventDetails({slug: code, guest_reviewer_id: 1})
       }
      })
      .catch((error) => {
        dispatch(updatePendingCallState({signin: false}))
       if(error) {
        const errorObject = error?.response?.data;
        if(!!errorObject){
          showSnackBar(dispatch, errorObject);
         // //setSigninStatus("unverified");
        } else{
         // //setSigninStatus("error");
          gaEvents.loginFailed()
          // showSnackbar(errorObject)
        }
      }
      });
      }
    const acceptMemberInvitation = (payload, callback ) => {
        dispatch(setGuestReviewState({is_loading: true}))
        acceptMemberInvitationApi(payload) 
        .then((response) => {
          //console.log("response", response?.data)
          if(response?.data?.http_code == 200){
             // //setSigninStatus("success");
              gaEvents.loginEvent()
              window.localStorage.setItem("token", response?.data?.data?.token);
              dispatch(
                updateState({
                  is_logged: true,
                  user_name: response?.data?.data?.name,
                  user_id: response?.data?.data?.id,
                  // company_name:response?.data?.company_name,
                  // show_revision_tutorial: response?.data?.show_revision_tutorial,
                  // is_company_name_available: response?.data?.company_name  ? true : false,
                })
              );
              dispatch(updateProjectState({is_org_projects_loading: true}))
              // dispatch(setAssetState({
              //   is_brand_name_available: response?.data?.company_name  ? true : false,
              // }))
        
              getPermissions(dispatch)
              // getTheme(dispatch)
             
              
            navigate("/", {replace: true});
            // console.log(response.data.data.guest_reviewer_id)
          //   getGuestEventDetails({slug:code, guest_reviewer_id: response?.data?.data?.guest_reviewer_id }, callback)
          //   dispatch(setGuestReviewState({guest_reviewer_id: response.data.data.guest_reviewer_id}))
          //  callback && callback()
            // getGuestEventDetails({slug: code, guest_reviewer_id: 1})
         }
        })
        .catch((error) => {
         if(error) {
          const errorObject = error?.response?.data;
          if(errorObject.data && errorObject.data.email_verified == false){
            showSnackBar(dispatch, errorObject);
           // //setSigninStatus("unverified");
          } else{
           // //setSigninStatus("error");
            gaEvents.loginFailed()
            // showSnackbar(errorObject)
          }
        }
        });
        }

      const forgotPassword = (payload, callback ) => {
        dispatch(updatePendingCallState({forgotPassword: true}))
        forgotPasswordApi(payload) 
        .then((response) => {
          dispatch(updatePendingCallState({forgotPassword: false}))
          if(response?.data?.http_code === 200){
            dispatch(setSnackbar({type: "success", flag: true, message: response?.data?.message}))
            setTimeout(()=> {
              navigate('signin', {replace: true})
            }, 2000)
              //setSigninStatus("success");
             // gaEvents.loginEvent()
             // window.localStorage.setItem("token", response?.data?.token);
              // dispatch(
              //   updateState({
              //     is_logged: true,
              //     user_name: response?.data?.name,
              //     user_id: response?.data?.user_id,
              //     company_name:response?.data?.company_name,
              //     show_revision_tutorial: response?.data?.show_revision_tutorial,
              //     is_company_name_available: response?.data?.company_name  ? true : false,
              //   })
              // );
              // dispatch(setAssetState({
              //   is_brand_name_available: response?.data?.company_name  ? true : false,
              // }))
        
              // getPermissions(dispatch)
              // getTheme(dispatch)
             
             // navigate("/", {replace: true});
            // console.log(response.data.data.guest_reviewer_id)
          //   getGuestEventDetails({slug:code, guest_reviewer_id: response?.data?.data?.guest_reviewer_id }, callback)
          //   dispatch(setGuestReviewState({guest_reviewer_id: response.data.data.guest_reviewer_id}))
          //  callback && callback()
            // getGuestEventDetails({slug: code, guest_reviewer_id: 1})
         }
        })
        .catch((error) => {
          dispatch(updatePendingCallState({forgotPassword: false}))
         if(error) {
          const errorObject = error?.response?.data;
          if(errorObject.data && errorObject.data.email_verified == false){
            showSnackBar(dispatch, errorObject);
            //setSigninStatus("unverified");
          } 
        }
        });
        }


        const resetPassword = (payload, callback ) => {
          dispatch(updatePendingCallState({resetPassword: true}))
          resetPasswordApi(payload) 
          .then((response) => {
            dispatch(updatePendingCallState({resetPassword: false}))
            console.log(" reset password response", response?.data)
            if(response?.data?.http_code === 200){
              callback && callback(true);
                //setSigninStatus("success");
                // gaEvents.loginEvent()
                // window.localStorage.setItem("token", response?.data?.token);
                // dispatch(
                //   updateState({
                //     is_logged: true,
                //     user_name: response?.data?.name,
                //     user_id: response?.data?.user_id,
                //     company_name:response?.data?.company_name,
                //     show_revision_tutorial: response?.data?.show_revision_tutorial,
                //     is_company_name_available: response?.data?.company_name  ? true : false,
                //   })
                // );
                // dispatch(setAssetState({
                //   is_brand_name_available: response?.data?.company_name  ? true : false,
                // }))
          
                // getPermissions(dispatch)
                // getTheme(dispatch)
               
                // navigate("/", {replace: true});
              // console.log(response.data.data.guest_reviewer_id)
            //   getGuestEventDetails({slug:code, guest_reviewer_id: response?.data?.data?.guest_reviewer_id }, callback)
            //   dispatch(setGuestReviewState({guest_reviewer_id: response.data.data.guest_reviewer_id}))
            //  callback && callback()
              // getGuestEventDetails({slug: code, guest_reviewer_id: 1})
           }
          })
          .catch((error) => {
            dispatch(updatePendingCallState({resetPassword: false}))
           if(error) {
            const errorObject = error?.response?.data;
            if(errorObject.data && errorObject.data.email_verified == false){
              showSnackBar(dispatch, errorObject);
              //setSigninStatus("unverified");
            } 
          }
          });
          }


          
        const resendLink = (payload, callback ) => {
          dispatch(setGuestReviewState({is_loading: true}))
          registerGuestApi(payload) 
          .then((response) => {
            if(response?.data?.http_code === 200){
                //setSigninStatus("success");
                gaEvents.loginEvent()
                window.localStorage.setItem("token", response?.data?.token);
                dispatch(
                  updateState({
                    is_logged: true,
                    user_name: response?.data?.name,
                    user_id: response?.data?.user_id,
                    company_name:response?.data?.company_name,
                    show_revision_tutorial: response?.data?.show_revision_tutorial,
                    is_company_name_available: response?.data?.company_name  ? true : false,
                  })
                );
                dispatch(setAssetState({
                  is_brand_name_available: response?.data?.company_name  ? true : false,
                }))
          
                getPermissions(dispatch)
                getTheme(dispatch)
               
                navigate("/", {replace: true});
              // console.log(response.data.data.guest_reviewer_id)
            //   getGuestEventDetails({slug:code, guest_reviewer_id: response?.data?.data?.guest_reviewer_id }, callback)
            //   dispatch(setGuestReviewState({guest_reviewer_id: response.data.data.guest_reviewer_id}))
            //  callback && callback()
              // getGuestEventDetails({slug: code, guest_reviewer_id: 1})
           }
          })
          .catch((error) => {
           if(error) {
            const errorObject = error?.response?.data;
            if(errorObject.data && errorObject.data.email_verified == false){
              showSnackBar(dispatch, errorObject);
              //setSigninStatus("unverified");
            } else{
              //setSigninStatus("error");
              gaEvents.loginFailed()
              // showSnackbar(errorObject)
            }
          }
          });
          }


          
        const verifyUserToken = (payload, callback ) => {
          dispatch(setGuestReviewState({is_loading: true}))
          checkVerificationTokenApi(payload) 
          .then((response) => {
            dispatch(setGuestReviewState({is_loading: false}))
            console.log(" check token response", response?.data)
            if(response?.data?.http_code === 200){
              const isValid = !(response?.data?.message == "Link has expired or already used")
                callback(isValid)
              
                //setSigninStatus("success");
                // gaEvents.loginEvent()
                // window.localStorage.setItem("token", response?.data?.token);
                // dispatch(
                //   updateState({
                //     is_logged: true,
                //     user_name: response?.data?.name,
                //     user_id: response?.data?.user_id,
                //     company_name:response?.data?.company_name,
                //     show_revision_tutorial: response?.data?.show_revision_tutorial,
                //     is_company_name_available: response?.data?.company_name  ? true : false,
                //   })
                // );
                // dispatch(setAssetState({
                //   is_brand_name_available: response?.data?.company_name  ? true : false,
                // }))
          
                // getPermissions(dispatch)
                // getTheme(dispatch)
               
                // navigate("/", {replace: true});
              // console.log(response.data.data.guest_reviewer_id)
            //   getGuestEventDetails({slug:code, guest_reviewer_id: response?.data?.data?.guest_reviewer_id }, callback)
            //   dispatch(setGuestReviewState({guest_reviewer_id: response.data.data.guest_reviewer_id}))
            //  callback && callback()
              // getGuestEventDetails({slug: code, guest_reviewer_id: 1})
           }
          })
          .catch((error) => {
            dispatch(setGuestReviewState({is_loading: false}))
           if(error) {
            const errorObject = error?.response?.data;
            if(errorObject.data && errorObject.data.email_verified == false){
              showSnackBar(dispatch, errorObject);
              //setSigninStatus("unverified");
            } else{
              // //setSigninStatus("error");
              gaEvents.loginFailed()
              // showSnackbar(errorObject)
            }
          }
          });
          }


          
        const checkInvitation = (payload, callback ) => {
          dispatch(setGuestReviewState({is_loading: true}))
          checkInvitationApi(payload) 
          .then((response) => {
            dispatch(setGuestReviewState({is_loading: false}))
            if(response?.data?.http_code === 200){
                //setSigninStatus("success");
                gaEvents.loginEvent()
                callback(true)
                // dispatch(setAssetState({
                //   is_brand_name_available: response?.data?.company_name  ? true : false,
                // }))
          
               // getPermissions(dispatch)
                // getTheme(dispatch)
               
               // navigate("/", {replace: true});
              // console.log(response.data.data.guest_reviewer_id)
            //   getGuestEventDetails({slug:code, guest_reviewer_id: response?.data?.data?.guest_reviewer_id }, callback)
            //   dispatch(setGuestReviewState({guest_reviewer_id: response.data.data.guest_reviewer_id}))
            //  callback && callback()
              // getGuestEventDetails({slug: code, guest_reviewer_id: 1})
           }
          })
          .catch((error) => {
           if(error) {
            dispatch(setGuestReviewState({is_loading: false}))
            const errorObject = error?.response?.data;
            if(errorObject?.http_code == 401) {
              callback(false)
            }
            //console.log({errorObject})
            if(errorObject.data && errorObject.data.email_verified == false){
              showSnackBar(dispatch, errorObject);
              //setSigninStatus("unverified");
            } else{
              // //setSigninStatus("error");
              gaEvents.loginFailed()
              // showSnackbar(errorObject)
            }
          }
          });
          }


          
        const checkResetPasswordTokenValidity = (payload, callback ) => {
          dispatch(updatePendingCallState({checkResetTokenValidity: true}))
          checkResetTokenValidityApi(payload) 
          .then((response) => {
            dispatch(updatePendingCallState({checkResetTokenValidity: false}))
            if(response?.data?.http_code === 200){
                callback && callback(response?.data?.data?.is_valid)
              
           }
          })
          .catch((error) => {
            dispatch(updatePendingCallState({checkResetTokenValidity: false}))
           if(error) {
            const errorObject = error?.response?.data;
            if(errorObject.data){
              showSnackBar(dispatch, errorObject);
              //setSigninStatus("unverified");
            } 
          }
          });
          }


    

  return {  
    signinUser,
    forgotPassword,
    resetPassword,
    verifyUserToken,
    checkResetPasswordTokenValidity,
    acceptMemberInvitation,
    checkInvitation
  };
}